/** Shared scroll offsets for browser back/forward; cleared on logout from layoutSlice. */
const MAX_ENTRIES = 50;

const scrollPositionsByKey = new Map<string, number>();

function trimToCap() {
  while (scrollPositionsByKey.size > MAX_ENTRIES) {
    const oldest = scrollPositionsByKey.keys().next().value as string | undefined;
    if (oldest === undefined) break;
    scrollPositionsByKey.delete(oldest);
  }
}

export function setScrollPositionForKey(key: string, scrollTop: number): void {
  scrollPositionsByKey.set(key, scrollTop);
  trimToCap();
}

export function getScrollPositionForKey(key: string): number | undefined {
  return scrollPositionsByKey.get(key);
}

/** Drop all saved positions (e.g. on logout). */
export function clearScrollRestorationStorage(): void {
  scrollPositionsByKey.clear();
}

/** @internal testing only */
export function __getScrollRestorationStorageSize(): number {
  return scrollPositionsByKey.size;
}
